// Module
var code = "<concierge-form redirect=$ctrl.redirectTo(url) track-event=\"$ctrl.trackEvent(lead, client)\" view-ready=$ctrl.viewReady() user=$ctrl.$user.$></concierge-form>";
// Exports
module.exports = code;